// Avoid floating-point rounding of the API's 18-digit integer amounts.
export function normalizeAmount(value) {
  const text = String(value ?? '').trim().replace(',', '.')
  if (!/^-?\d{1,18}(\.\d{1,2})?$/.test(text)) return null
  const [whole, fraction = ''] = text.split('.')
  return `${whole}.${fraction.padEnd(2, '0')}`
}

export function currencyLabel(currency = '') {
  return currency === 'EUR' ? '€' : currency
}

export function balanceOrigin(balance) {
  if (!balance) return ''
  const source = { manual: 'Manuell', excel: 'Excel', stocks: 'Positionen', rule: 'Jährliche Bewertung' }[balance.source || 'manual'] || balance.source
  const date = balance.updated_at ? new Date(balance.updated_at) : null
  return source + (date && !Number.isNaN(date.getTime()) ? ` · Aktualisiert: ${date.toLocaleString('de-DE')}` : '')
}

export function formatAmount(value, currency = '') {
  const text = String(value ?? '')
  if (!/^-?\d+(\.\d{1,2})?$/.test(text)) return '—'
  const [whole, fraction = ''] = text.split('.')
  // Round only the display, without losing precision for large API amounts.
  /* global BigInt */
  const rounded = BigInt(whole.replace(/^-/, '')) + (Number(fraction.padEnd(2, '0')) >= 50 ? BigInt(1) : BigInt(0))
  const digits = rounded.toString()
  return `${whole.startsWith('-') && rounded !== BigInt(0) ? '-' : ''}${digits.replace(/\B(?=(\d{3})+(?!\d))/g, '.')} ${currencyLabel(currency)}`.trim()
}

export function wealthError(error) {
  if (error?.response?.status === 401) return 'Bitte melde dich erneut an.'
  const detail = error?.response?.data?.detail
  if (typeof detail === 'string') return detail
  if (Array.isArray(detail)) {
    const labels = { name: 'Kontoname', institution: 'Institut', iban: 'IBAN', currency: 'Währung', amount: 'Betrag', notes: 'Notiz', account_type: 'Kontotyp', date: 'Datum', as_of: 'Stichtag', from: 'Von', to: 'Bis' }
    return detail.map(item => {
      const field = item.loc?.filter(part => !['body', 'query', 'path'].includes(part)).map(part => labels[part] || part).join(' · ')
      return `${field ? `${field}: ` : ''}${item.msg || 'Ungültiger Wert.'}`
    }).join(' ')
  }
  if (error?.response?.status === 404) return 'Die angefragten Daten sind derzeit nicht verfügbar.'
  return 'Die Anfrage ist fehlgeschlagen. Bitte versuche es erneut.'
}
